import React, { useEffect } from 'react';
import SectionTitle from '../components/SectionTitle';
import ServiceCard from '../components/ServiceCard';
import '../styles/Services.css';
import { FaPlaneDeparture, FaBuilding, FaFileAlt, FaCompass, FaSuitcaseRolling, FaStar } from "react-icons/fa";

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) setTimeout(() => e.target.classList.add('visible'), i * 80);
      });
    }, { threshold: 0.12 });
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

const SERVICES = [
  { num: '01', icon: <FaPlaneDeparture />, name: 'Overseas Job Placement', desc: 'We connect candidates with verified employers across countries in sectors like healthcare, IT, construction, hospitality, and more. Access hundreds of vetted international opportunities tailored to your skillset.' },
  { num: '02', icon: <FaBuilding />, name: 'HR Recruitment Solutions', desc: 'We help international companies find qualified and skilled professionals based on their specific requirements. Our customized hiring solutions ensure the perfect fit for your organization.' },
  { num: '03', icon: <FaFileAlt />, name: 'Visa & Immigration Assistance', desc: 'Our experts guide you through documentation, visa applications, and compliance processes to ensure a smooth transition. We handle the complexity so you can focus on your future.' },
  { num: '04', icon: <FaCompass />, name: 'Career Counseling', desc: 'We provide personalized guidance to help you choose the right country, role, and career path. Our counselors work with you to map out a strategic international career plan.' },
  { num: '05', icon: <FaSuitcaseRolling />, name: 'Pre-Departure Support', desc: 'From documentation to cultural orientation, we prepare you for a successful international career journey. Our comprehensive pre-departure briefings ensure you arrive confident and prepared.' },
  { num: '06', icon: <FaStar />, name: 'End-to-End Support', desc: 'Our relationship with clients doesn\'t end at placement. We provide ongoing post-arrival support, employer liaison, and career progression guidance to maximize your global success.' },
];

const SEEKER_LIST = [
  'Access to verified job openings worldwide',
  'Expert guidance at every step of the process',
  'Fast and reliable visa processing',
  'Personalized career counseling sessions',
  'Pre-departure orientation and support',
];

const EMPLOYER_LIST = [
  'Pre-screened and verified candidates',
  'Fast and efficient recruitment process',
  'Customized hiring solutions for your sector',
  'Compliance and documentation handled',
  'Workforce diversity consulting',
];

const Services = ({ onNavigate }) => {
  useReveal();

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="page-hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1600&q=80')" }} />
        <div className="page-hero-content">
          <span className="section-tag">What We Offer</span>
          <h1 className="page-hero-title">Our <em>Premium</em><br />Services</h1>
          <div className="section-line" />
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <SectionTitle tag="Comprehensive Solutions" heading="Everything You <em>Need</em>" center style={{ color: "black" }} />
        <div className="services-grid">
          {SERVICES.map(s => (
            <div className="fade-up" key={s.num}>
              <ServiceCard
                num={s.num}
                icon={s.icon}
                name={s.name}
                description={s.desc}
                onEnquire={() => onNavigate('contact')}
              />
            </div>
          ))}
        </div>
      </section>

      {/* For Seekers / Employers */}
      <div className="fe-panels">
        {/* Seekers */}
        <div className="fe-panel fe-panel--seeker">
          <div className="fe-panel__content">
            <span className="section-tag">Individuals</span>
            <h2 className="section-heading" style={{ fontSize: 'clamp(28px,3vw,44px)' }}>
              For Job <em>Seekers</em>
            </h2>
            <div className="section-line" />
            <p>Looking to work abroad? We make it simple. Our streamlined process connects you to verified international opportunities fast.</p>
            <ul className="fe-panel__list">
              {SEEKER_LIST.map(item => <li key={item}>{item}</li>)}
            </ul>
            <button className="btn-gold" onClick={() => onNavigate('contact')}>Start Your Journey</button>
          </div>
        </div>

        {/* Employers */}
        <div className="fe-panel fe-panel--employer">
          <div className="fe-panel__content">
            <span className="section-tag">Organizations</span>
            <h2 className="section-heading" style={{ fontSize: 'clamp(28px,3vw,44px)' }}>
              For <em>Employers</em>
            </h2>
            <div className="section-line" />
            <p>Need skilled international talent? We deliver pre-screened, qualified candidates matched precisely to your requirements.</p>
            <ul className="fe-panel__list">
              {EMPLOYER_LIST.map(item => <li key={item}>{item}</li>)}
            </ul>
            <button className="btn-gold" onClick={() => onNavigate('contact')}>Find Talent Now</button>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="cta-band">
        <p className="cta-text">
          Let's discuss the <em>perfect solution</em><br />for your unique needs.
        </p>
        <button
          className="btn-gold"
          style={{ whiteSpace: 'nowrap', padding: '18px 50px', fontSize: 11 }}
          onClick={() => onNavigate('contact')}
        >
          Get Free Consultation
        </button>
      </div>
    </>
  );
};

export default Services;